import { updateBankingDetails as sdkUpdateBankingDetails } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { UpdateBankingDetailsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function linkBankAccount(
  data: UpdateBankingDetailsRequestT,
  signal?: AbortSignal
): Promise<string> {
  const config = await createLotusRequestConfig({ signal });
  const response = await sdkUpdateBankingDetails(data, config);
  return response.data.proposed?.accountHolderName ?? data.accountHolderName;
}
